export default __webpack_public_path__ + "static/media/mariog7.50432c43.jpg";